import { PermissionWrapper } from '../../../components/accessControl/PermissionWrapper';
import { ePermissions } from '../../../types/administration/userAdministration/ePermissions';
import React from 'react';
import { useListTagsQuery } from '../../../API/tags/TagApi';
import { TagsPage } from './TagsPage';
import { ErrorMessageTW } from '../../../tailwindComponents/errorMessage/ErrorMessageTW';

export const TagsContainer: React.FC = () => {
  const { data: allTags = [], error: tagsFetchError } = useListTagsQuery();

  return (
    <PermissionWrapper allowedPermissions={[ePermissions.TagEdit]}>
      <ErrorMessageTW rtkError={tagsFetchError} />
      <TagsPage tags={allTags} />
    </PermissionWrapper>
  );
};
